import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Sidebar.css';
import '../styles/SidebarPinnedHelp.css';   // Help pinned to the bottom (client item #21)
import { SYSTEMS_ENABLED } from './featureFlags.js';  // Systems hidden for v1.0
// import kinetiqLogo from '../../src/components/kinetiq_logo4.png';
// import '../components/Contact';


/* ─── Inline SVG Icons ────────────────────────────────────────
   No external dep — hand-crafted SVGs for a scientific dashboard.
──────────────────────────────────────────────────────────────── */
const Icon = {
  Dashboard: () => (
    <svg width="16" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5"/>
      <rect x="14" y="3" width="7" height="7" rx="1.5"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5"/>
      <rect x="14" y="14" width="7" height="7" rx="1.5"/>
    </svg>
  ),
  Users: () => (
    <svg width="16" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  DataFitting: () => (
    <svg width="16" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="18" rx="2"/>
      <path d="M4 18L8 12L12 15L17 8L21 11"/>
      <circle cx="8" cy="12" r="1.5" fill="currentColor"/>
      <circle cx="12" cy="15" r="1.5" fill="currentColor"/>
      <circle cx="17" cy="8" r="1.5" fill="currentColor"/>
    </svg>
  ),
  Simulation: () => (
    <svg width="16" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="5 3 19 12 5 21 5 3"/>
    </svg>
  ),
  CompareFits: () => (
    <svg width="16" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v18h18"/>
      <path d="M7 15l4-5 3 3 5-7" strokeDasharray="0"/>
      <path d="M7 12l4-4 3 3 5-6" opacity="0.45"/>
      <circle cx="7" cy="15" r="1.2" fill="currentColor" stroke="none"/>
      <circle cx="11" cy="10" r="1.2" fill="currentColor" stroke="none"/>
      <circle cx="14" cy="13" r="1.2" fill="currentColor" stroke="none"/>
      <circle cx="19" cy="6" r="1.2" fill="currentColor" stroke="none"/>
    </svg>
  ),
  Projects: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 9V6a2 2 0 0 1 2-2h3l2 3h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9z"/>
    </svg>
  ),
  History: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="1 4 1 10 7 10"/>
      <path d="M3.51 15a9 9 0 1 0 .49-4.87"/>
      <polyline points="12 7 12 12 15 14"/>
    </svg>
  ),
  Jobs: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2"/>
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
      <line x1="12" y1="12" x2="12" y2="16"/>
      <line x1="10" y1="14" x2="14" y2="14"/>
    </svg>
  ),
  Help: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
      <circle cx="12" cy="17" r="0.5" fill="currentColor"/>
    </svg>
  ),
  ChevronDown: ({ rotated }) => (
    <svg
      width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
      style={{ transform: rotated ? 'rotate(180deg)' : 'none', transition: 'transform 0.25s cubic-bezier(0.4,0,0.2,1)', display: 'block' }}
    >
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
  CollapseLeft: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
      <line x1="19" y1="12" x2="10" y2="12"/>
    </svg>
  ),
  ExpandRight: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
      <line x1="5" y1="12" x2="14" y2="12"/>
    </svg>
  ),
  Settings: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  Molecule: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="2.5"/>
      <circle cx="4.5" cy="6" r="2"/>
      <circle cx="19.5" cy="6" r="2"/>
      <circle cx="4.5" cy="18" r="2"/>
      <circle cx="19.5" cy="18" r="2"/>
      <line x1="6.5" y1="7" x2="10" y2="10.5"/>
      <line x1="17.5" y1="7" x2="14" y2="10.5"/>
      <line x1="6.5" y1="17" x2="10" y2="13.5"/>
      <line x1="17.5" y1="17" x2="14" y2="13.5"/>
    </svg>
  ),
  // Sub-panel icons
  Sub: {
    Input: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="12" rx="2"/>
        <path d="M8 19h8M12 15v4"/>
        <path d="M7 8h4M7 11.5h6"/>
      </svg>
    ),
    Graph: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <polyline points="5 18 9 12 13 15 18 8"/>
        <circle cx="18" cy="8" r="1.5" fill="currentColor"/>
      </svg>
    ),
    Parameters: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7h16M4 12h10M4 17h6"/>
        <circle cx="19" cy="12" r="3"/>
        <line x1="22" y1="15" x2="24" y2="17"/>
      </svg>
    ),
    Optimize: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/>
        <circle cx="12" cy="12" r="3"/>
        <line x1="12" y1="3" x2="12" y2="6"/>
        <line x1="12" y1="18" x2="12" y2="21"/>
        <line x1="3" y1="12" x2="6" y2="12"/>
        <line x1="18" y1="12" x2="21" y2="12"/>
      </svg>
    ),
    RunHistory: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="1 4 1 10 7 10"/>
        <path d="M3.51 15a9 9 0 1 0 .49-4.87"/>
        <polyline points="12 7 12 12 15 14"/>
      </svg>
    ),
    Compare: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 17c3-8 6-11 9-11M4 17h16" opacity="0.45"/>
        <path d="M4 7c3 8 6 11 9 11M20 7v10"/>
      </svg>
    ),
    Appendix: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="8" y1="13" x2="16" y2="13"/>
        <line x1="8" y1="17" x2="12" y2="17"/>
      </svg>
    ),
    // Help sub-item icons
    UserGuide: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="8" y1="13" x2="16" y2="13"/>
        <line x1="8" y1="17" x2="12" y2="17"/>
      </svg>
    ),
    Examples: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
      </svg>
    ),
    Tutorials: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <polygon points="10 8 16 12 10 16 10 8" fill="currentColor" stroke="none"/>
      </svg>
    ),
    ContactUs: () => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
    // Small bullet used for the User Guide's own section links —
    // deliberately generic since there are 8 of them.
    Dot: () => (
      <svg width="7" height="7" viewBox="0 0 8 8" fill="currentColor">
        <circle cx="4" cy="4" r="4"/>
      </svg>
    ),
  },
};

/* ─── Data Fitting sub-items ──────────────────────────────── */
// Compare Fit now routes to its own page (/compare-fits, CompareFitsPage.jsx)
// instead of the old #compare hash tab inside DataFittingPage — same `path`
// pattern Help's Contact Us already uses below. Every other Data Fitting
// sub-item is still a hash tab within DataFittingPage.
// Run History is no longer listed here (client request): it is reached via
// "Reports" in the main menu and the dashboard's "View all" links.
const DATA_FITTING_SUBITEMS = [
  { hash: '#input',    label: 'Input',        NavIcon: Icon.Sub.Input      },
  { hash: '#graph',    label: 'Graph',        NavIcon: Icon.Sub.Graph      },
  { hash: '#output',   label: 'Parameters',   NavIcon: Icon.Sub.Parameters },
  { hash: '#optimize', label: 'Optimize',     NavIcon: Icon.Sub.Optimize   },
  { path: '/compare-fits', label: 'Compare Fit',  NavIcon: Icon.Sub.Compare    },
  { hash: '#appendix', label: 'Appendix',     NavIcon: Icon.Sub.Appendix   },
];

/* ─── Help sub-items ──────────────────────────────────────────
   contact-us uses a React Router path so it navigates to the
   dedicated /contact page. The others stay as scroll-select.
───────────────────────────────────────────────────────────── */
const HELP_SUBITEMS = [
  { id: 'user-guide',  label: 'User Guide',  NavIcon: Icon.Sub.UserGuide, path: '/userguide'},
  { id: 'examples',    label: 'Examples',    NavIcon: Icon.Sub.Examples,  path: '/examples'},
  { id: 'settings',    label: 'Settings',    NavIcon: Icon.Settings,     path: '/edit-account' },
  { id: 'contact-us',  label: 'Contact Us',  NavIcon: Icon.Sub.ContactUs, path: '/contact'  },
];

/* ─── User Guide's own sections ─────────────────────────────────
   The User Guide page loads its sections dynamically (only the
   active one is mounted, no full-page scrolling). These links jump
   straight to a section by pointing at /userguide#<hash> — same
   page, no reload, UserGuide.jsx reads the hash and swaps content.
   Rendered as a nested list under "User Guide" whenever that page
   is open, so the always-visible app sidebar can drive the guide
   directly instead of relying on the guide's own internal nav rail.
───────────────────────────────────────────────────────────────── */
const USER_GUIDE_SUBITEMS = [
  { hash: 'data-model-input', label: 'Data & Model Input' },
  { hash: 'running-program',  label: 'Running the Program' },
  { hash: 'understanding-results', label: 'Understanding Results' },
  { hash: 'optimization-comparison', label: 'Optimization & Comparison' },
  { hash: 'examples',         label: 'Examples' },
  { hash: 'troubleshooting',  label: 'Troubleshooting' },
];

/* ─── Menu config per role ────────────────────────────────── */
const MENU = {
  Admin: [
    { path: '/dashboard',       label: 'Dashboard',       NavIcon: Icon.Dashboard   },
    { path: '/user-management', label: 'Manage Users',    NavIcon: Icon.Users       },
    { path: '/data-fitting',    label: 'Data Fitting',    NavIcon: Icon.DataFitting, hasSubMenu: true },
    { path: '/upload',          label: 'Run Simulation',  NavIcon: Icon.Simulation  },
    { path: '/projects',        label: 'Projects',        NavIcon: Icon.Projects    },
    { path: '/project-history', label: 'Project History', NavIcon: Icon.History     },
    { path: '/help',            label: 'Support',         NavIcon: Icon.Help,        hasHelpMenu: true },
  ],
  BusinessUser: [
    { path: '/dashboard',       label: 'Dashboard',       NavIcon: Icon.Dashboard   },
    { path: '/data-fitting',    label: 'Data Fitting',    NavIcon: Icon.DataFitting, hasSubMenu: true },
    { path: '/upload',          label: 'Run Simulation',  NavIcon: Icon.Simulation  },
    { path: '/job-status',      label: 'View Jobs',       NavIcon: Icon.Jobs        },
    { path: '/projects',        label: 'Projects',        NavIcon: Icon.Projects    },
    { path: '/project-history', label: 'Project History', NavIcon: Icon.History     },
    { path: '/help',            label: 'Support',         NavIcon: Icon.Help,        hasHelpMenu: true },
  ],
  AssociateResearcher: [
    { path: '/dashboard',       label: 'Dashboard',       NavIcon: Icon.Dashboard   },
    { path: '/data-fitting',    label: 'Data Fitting',    NavIcon: Icon.DataFitting, hasSubMenu: true },
    { path: '/systems',         label: 'Systems',         NavIcon: Icon.Molecule    },
    { path: '/run-history',     label: 'Reports',         NavIcon: Icon.History     },
    { path: '/help',            label: 'Support',         NavIcon: Icon.Help,        hasHelpMenu: true },
  ],
  PrincipalResearcher: [
    { path: '/dashboard',       label: 'Dashboard',       NavIcon: Icon.Dashboard   },
    { path: '/data-fitting',    label: 'Data Fitting',    NavIcon: Icon.DataFitting, hasSubMenu: true },
    { path: '/systems',         label: 'Systems',         NavIcon: Icon.Molecule    },
    { path: '/run-history',     label: 'Reports',         NavIcon: Icon.History     },
    { path: '/help',            label: 'Support',         NavIcon: Icon.Help,        hasHelpMenu: true },
  ],
};

/* ─── Sidebar component ─────────────────────────────────────── */
const Sidebar = () => {
  const role = localStorage.getItem('role') || 'Admin';
  const location = useLocation();
  const navigate = useNavigate();
  // FIX (Data Fitting submenu collapsed on Compare Fit): Compare Fit is its own page
  // (/compare-fits), so "am I in Data Fitting?" was false there and the submenu
  // (rebuilt with each page's Sidebar) started collapsed. Every Data Fitting
  // sub-item that is a route of its own now counts as being inside the section.
  const dataFittingPaths = ['/data-fitting', ...DATA_FITTING_SUBITEMS.map(i => i.path).filter(Boolean)];
  const isOnDataFitting = dataFittingPaths.includes(location.pathname);

  const helpSubPaths = HELP_SUBITEMS.map(i => i.path).filter(Boolean);
  const isOnHelpSubPage = helpSubPaths.includes(location.pathname);
  const isOnUserGuidePage = location.pathname === '/userguide';

  const [dfExpanded,    setDfExpanded]    = useState(isOnDataFitting);
  const [helpExpanded,  setHelpExpanded]  = useState(isOnHelpSubPage);
  const [guideExpanded, setGuideExpanded] = useState(isOnUserGuidePage);
  const [activeHelpId,  setActiveHelpId]  = useState(null);
  const [collapsed,     setCollapsed]     = useState(false);
  const [hoveredPath,   setHoveredPath]   = useState(null);
  const [hoveredHash,   setHoveredHash]   = useState(null);
  const [hoveredHelpId, setHoveredHelpId] = useState(null);

  useEffect(() => {
    if (isOnDataFitting) setDfExpanded(true);
  }, [isOnDataFitting]);

  useEffect(() => {
    if (isOnHelpSubPage) setHelpExpanded(true);
  }, [isOnHelpSubPage]);

  useEffect(() => {
    if (isOnUserGuidePage) setGuideExpanded(true);
  }, [isOnUserGuidePage]);

  // Systems is hidden for v1.0 (see featureFlags.js); Reports stays.
  const items = (MENU[role] || []).filter((i) => SYSTEMS_ENABLED || i.path !== '/systems');
  // Help & Resources (User Guide, Examples, Settings, Contact Us) is pinned
  // to the bottom of the sidebar, leaving a gap after the main navigation
  // (client item #21). Only roles whose menu has a Help entry get the block.
  const mainItems = items.filter((i) => !i.hasHelpMenu);
  const helpItems = items.filter((i) => i.hasHelpMenu);

  const renderNavItem = ({ path, label, NavIcon: NavIconComp, hasSubMenu, hasHelpMenu }) => {
      const isDataFitting = hasSubMenu && path === '/data-fitting';
      const isActive      = location.pathname === path
        || (hasHelpMenu && isOnHelpSubPage)
        || (isDataFitting && isOnDataFitting);   // keep the Data Fitting row highlighted on Compare Fit
      const isHelp        = hasHelpMenu && path === '/help';
      const isHovered     = hoveredPath === path;

      return (
        <React.Fragment key={path}>
          {/* Main row */}
          <div
            className="sb-nav-row"
            onMouseEnter={() => setHoveredPath(path)}
            onMouseLeave={() => setHoveredPath(null)}
          >
            {/* Data Fitting: button with embedded chevron (same pattern as Help) */}
            {isDataFitting ? (
              <button
                className={[
                  'sb-nav-link sb-nav-link--btn',
                  isActive || dfExpanded ? 'sb-nav-link--active' : '',
                  isHovered && !isActive && !dfExpanded ? 'sb-nav-link--hover' : '',
                ].join(' ')}
                onClick={() => setDfExpanded(e => !e)}
              >
                {(isActive || dfExpanded) && <span className="sb-accent-bar" />}
                <span className={`sb-nav-icon${isActive || dfExpanded ? ' sb-nav-icon--active' : ''}`}>
                  <NavIconComp />
                </span>
                <span className="sb-nav-label">{label}</span>
                <span className="sb-help-chevron">
                  <Icon.ChevronDown rotated={dfExpanded} />
                </span>
              </button>
            ) : isHelp ? (
              <button
                className={[
                  'sb-nav-link sb-nav-link--btn',
                  isActive || helpExpanded ? 'sb-nav-link--active' : '',
                  isHovered && !isActive && !helpExpanded ? 'sb-nav-link--hover' : '',
                ].join(' ')}
                onClick={() => setHelpExpanded(e => !e)}
              >
                {(isActive || helpExpanded) && <span className="sb-accent-bar" />}
                <span className={`sb-nav-icon${isActive || helpExpanded ? ' sb-nav-icon--active' : ''}`}>
                  <NavIconComp />
                </span>
                <span className="sb-nav-label">{label}</span>
                <span className="sb-help-chevron">
                  <Icon.ChevronDown rotated={helpExpanded} />
                </span>
              </button>
            ) : (
              <Link
                to={path}
                className={[
                  'sb-nav-link',
                  isActive  ? 'sb-nav-link--active'  : '',
                  isHovered && !isActive ? 'sb-nav-link--hover' : '',
                ].join(' ')}
              >
                {isActive && <span className="sb-accent-bar" />}
                <span className={`sb-nav-icon${isActive ? ' sb-nav-icon--active' : ''}`}>
                  <NavIconComp />
                </span>
                <span className="sb-nav-label">{label}</span>
              </Link>
            )}
          </div>

          {/* Data Fitting sub-menu */}
          {isDataFitting && dfExpanded && (
            <div className="sb-sub-menu">
              {DATA_FITTING_SUBITEMS.map(({ hash, path: subPath, label: subLabel, NavIcon: SubIconComp }) => {
                const key = subPath || hash;
                // Generic hash-or-path sub-item support (Help's
                // Contact Us uses `path`; every Data Fitting sub-item,
                // including Compare Fit, uses `hash` — a tab within
                // DataFittingPage, not its own route).
                const isSubActive  = subPath ? location.pathname === subPath : (location.pathname === '/data-fitting' && location.hash === hash);
                const isSubHovered = hoveredHash === key;
                return (
                  <Link
                    key={key}
                    to={subPath || `/data-fitting${hash}`}
                    className={[
                      'sb-sub-link',
                      isSubActive  ? 'sb-sub-link--active'  : '',
                      isSubHovered && !isSubActive ? 'sb-sub-link--hover' : '',
                    ].join(' ')}
                    onMouseEnter={() => setHoveredHash(key)}
                    onMouseLeave={() => setHoveredHash(null)}
                  >
                    <span className={`sb-sub-icon${isSubActive ? ' sb-sub-icon--active' : ''}`}>
                      <SubIconComp />
                    </span>
                    <span>{subLabel}</span>
                    {isSubActive && <span className="sb-sub-dot" />}
                  </Link>
                );
              })}
            </div>
          )}

          {/* Help sub-menu — Contact Us routes to /contact, others scroll-select */}
          {isHelp && helpExpanded && (
            <div className="sb-sub-menu sb-help-menu">
              {HELP_SUBITEMS.map(({ id, label: subLabel, NavIcon: SubIconComp, path: subPath }) => {
                const isUserGuide  = id === 'user-guide';
                const isSubActive  = subPath ? location.pathname === subPath : activeHelpId === id;
                const isSubHovered = hoveredHelpId === id;
                const sharedClass  = [
                  'sb-sub-link',
                  (isSubActive || (isUserGuide && guideExpanded)) ? 'sb-sub-link--active'  : '',
                  isSubHovered && !isSubActive ? 'sb-sub-link--hover' : '',
                ].join(' ');

                return (
                  <React.Fragment key={id}>
                    {isUserGuide ? (
                      // Same dropdown pattern as "Data Fitting" — a
                      // toggle button with an embedded chevron, not a
                      // plain link, since its real destinations are
                      // the section links revealed underneath it.
                      <button
                        className={`${sharedClass} sb-sub-link--btn`}
                        /* Clicking "User Guide" opens the guide; if already there, it toggles the section list. */
                        onClick={() => {
                          if (!isOnUserGuidePage) {
                            navigate('/userguide');
                            setGuideExpanded(true);
                          } else {
                            setGuideExpanded(e => !e);
                          }
                        }}
                        onMouseEnter={() => setHoveredHelpId(id)}
                        onMouseLeave={() => setHoveredHelpId(null)}
                      >
                        <span className={`sb-sub-icon${(isSubActive || guideExpanded) ? ' sb-sub-icon--active' : ''}`}>
                          <SubIconComp />
                        </span>
                        <span>{subLabel}</span>
                        <span className="sb-sub-chevron">
                          <Icon.ChevronDown rotated={guideExpanded} />
                        </span>
                      </button>
                    ) : subPath ? (
                      <Link
                        to={subPath}
                        className={sharedClass}
                        onMouseEnter={() => setHoveredHelpId(id)}
                        onMouseLeave={() => setHoveredHelpId(null)}
                      >
                        <span className={`sb-sub-icon${isSubActive ? ' sb-sub-icon--active' : ''}`}>
                          <SubIconComp />
                        </span>
                        <span>{subLabel}</span>
                        {isSubActive && <span className="sb-sub-dot" />}
                      </Link>
                    ) : (
                      <button
                        className={`${sharedClass} sb-sub-link--btn`}
                        onClick={() => setActiveHelpId(prev => prev === id ? null : id)}
                        onMouseEnter={() => setHoveredHelpId(id)}
                        onMouseLeave={() => setHoveredHelpId(null)}
                      >
                        <span className={`sb-sub-icon${isSubActive ? ' sb-sub-icon--active' : ''}`}>
                          <SubIconComp />
                        </span>
                        <span>{subLabel}</span>
                        {isSubActive && <span className="sb-sub-dot" />}
                      </button>
                    )}

                    {/* User Guide's own sections — dynamic loading:
                        these all point at /userguide, just with a
                        different hash, so clicking one swaps the
                        guide's content in place instead of leaving
                        this page. Toggled open/closed by the chevron
                        above, same as Data Fitting's sub-menu. */}
                    {isUserGuide && guideExpanded && (
                      <div className="sb-sub-menu sb-guide-menu">
                        {USER_GUIDE_SUBITEMS.map(({ hash, label: guideLabel }) => {
                          const isGuideActive =
                            isOnUserGuidePage && (
                              location.hash === `#${hash}` ||
                              (location.hash === '' && hash === 'data-model-input')
                            );
                          const isGuideHovered = hoveredHelpId === `guide-${hash}`;
                          return (
                            <Link
                              key={hash}
                              to={`/userguide#${hash}`}
                              className={[
                                'sb-sub-link',
                                isGuideActive  ? 'sb-sub-link--active'  : '',
                                isGuideHovered && !isGuideActive ? 'sb-sub-link--hover' : '',
                              ].join(' ')}
                              onMouseEnter={() => setHoveredHelpId(`guide-${hash}`)}
                              onMouseLeave={() => setHoveredHelpId(null)}
                            >
                              <span className={`sb-sub-icon${isGuideActive ? ' sb-sub-icon--active' : ''}`}>
                                <Icon.Sub.Dot />
                              </span>
                              <span>{guideLabel}</span>
                              {isGuideActive && <span className="sb-sub-dot" />}
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          )}
        </React.Fragment>
      );
  };

  const renderRailItem = ({ path, label, NavIcon: NavIconComp, hasHelpMenu }) => {
    const isActive = location.pathname === path || (hasHelpMenu && isOnHelpSubPage);
    return (
      <Link
        key={path}
        to={path}
        title={label}
        className={`sb-rail-item${isActive ? ' sb-rail-item--active' : ''}`}
      >
        <NavIconComp />
      </Link>
    );
  };

  /* ── Collapsed rail ── */
  if (collapsed) {
    return (
      <aside className="sb-rail">
        <div className="sb-rail-logo">
          <Icon.Molecule />
        </div>
        <nav className="sb-rail-nav">
          {mainItems.map(renderRailItem)}
        </nav>
        {helpItems.length > 0 && (
          <div className="sb-rail-bottom">
            {helpItems.map(renderRailItem)}
          </div>
        )}
        <button className="sb-rail-expand" onClick={() => setCollapsed(false)} title="Expand sidebar">
          <Icon.ExpandRight />
        </button>
      </aside>
    );
  }

  /* ── Full sidebar ── */
  return (
    <aside className="sb-sidebar">
      {/* Header */}
      <div className="sb-header">
        <div className="sb-logo-row">
          {/* <img
            src={kinetiqLogo}
            alt="KinetiQ – The Kinetics Platform"
            className="sb-logo-img"
          /> */}
        </div>
        <button className="sb-collapse-btn" onClick={() => setCollapsed(true)} title="Collapse sidebar">
          <Icon.CollapseLeft />
        </button>
      </div>

      {/* Divider */}
      <div className="sb-divider" />

      {/* Nav items */}
      <nav className="sb-nav">
        {mainItems.map(renderNavItem)}
      </nav>

      {/* Help & Resources — pinned to the bottom. A second .sb-nav so it inherits
          the exact same item styling/padding as the main navigation. */}
      {helpItems.length > 0 && (
        <nav className="sb-nav sb-bottom" aria-label="Help and resources">
          {helpItems.map(renderNavItem)}
        </nav>
      )}

    </aside>
  );
};

export default Sidebar;